"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGroupSizeBoundsForContracts = void 0;
const getActiveContracts_1 = require("./getActiveContracts");
const getGroupSizeBoundsForContracts = (date, contracts) => {
    const activeContracts = (0, getActiveContracts_1.getActiveContracts)(date, contracts);
    // get all the activeContracts.golf_contract_products[].golf_contract_product_rates into a single array
    const products = activeContracts.reduce((a, b) => {
        if (!b.products)
            return a;
        return [...a, ...b.products];
    }, []);
    const rates = products.reduce((a, b) => {
        if (!b.rates)
            return a;
        return [...a, ...b.rates];
    }, []);
    const min_pax = rates.reduce((a, b) => {
        return a < b.min_pax ? a : b.min_pax;
    }, 0);
    const max_pax = rates.reduce((a, b) => {
        return a > b.max_pax ? a : b.max_pax;
    }, 0);
    return { min_pax, max_pax };
};
exports.getGroupSizeBoundsForContracts = getGroupSizeBoundsForContracts;
